import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page-add" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "btn-group" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = { class: "form-text-viewer" }
const _hoisted_6 = {
  class: "text-viewer__inner",
  style: { width: '300px' }
}
const _hoisted_7 = { class: "form-text-viewer" }
const _hoisted_8 = {
  class: "text-viewer__inner",
  style: { width: '300px' }
}
const _hoisted_9 = { class: "form-text-viewer" }
const _hoisted_10 = {
  class: "text-viewer__inner",
  style: { width: '300px' }
}
const _hoisted_11 = { class: "form-text-viewer" }
const _hoisted_12 = { class: "text-viewer__inner" }
const _hoisted_13 = { class: "form-text-viewer" }
const _hoisted_14 = { class: "text-viewer__inner" }
const _hoisted_15 = { class: "section" }
const _hoisted_16 = { class: "section" }
const _hoisted_17 = { class: "document-col" }
const _hoisted_18 = { class: "document-col" }
const _hoisted_19 = { class: "document-col" }
const _hoisted_20 = { class: "document-col" }
const _hoisted_21 = { class: "section" }
const _hoisted_22 = { class: "btn-group" }

import { reactive, ref, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { RequestTypeKeys, optionsReqType, PaymentTypeKeys, PaymentCycleTypeKeys, DocumentTypeKeys, optionsDocumentType } from "@/types/constants";
import { disablePastDates, formatPhonNumber } from '@/utils';
import * as options from '@/utils/options';
import { getUserInfo, getCustomerInfo, createRequest } from "@/api";
import { ElMessage, ElMessageBox, ElInput, ElSelect } from 'element-plus'
import { usePlanStore } from "@/stores/plan";
import moment from "moment";

interface Form {
  userId: string,
  baRefer?: string,
  beusRefer?: string,
  companyName: string,
  customerId: string,
  manager: string,
  taxMail: string,
  requestType: RequestTypeKeys | undefined,
  beusPlanNumber: number | undefined,
  baPlanNumber: number | undefined,
  useStartDate: Date,
  period: string | undefined,
  useEndDate: Date | null,
  recurring: boolean | null,
  paymentType: PaymentTypeKeys,
  paymentCycle: PaymentCycleTypeKeys,
  amount: number,
  paymentDate: Date,
  isEndOfMonth: boolean,
  memo: string,
}

interface Document {
  docType: DocumentTypeKeys | undefined,
  actionDate: Date,
  email: 'tax' | 'manager' | 'system',
  periodic: boolean,
  isEndOfMonth: boolean
}

type InputRef = {
  focus: () => void;
  value?: string | number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AddPage',
  setup(__props) {

const router = useRouter();
const toBoard = () => router.push("/");
const toBack = () => {
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push('/');
  }
}

const form = reactive<Form>({
  userId: '',
  baRefer: '',
  beusRefer: '',
  companyName: '',
  customerId: '',
  manager: '',
  taxMail: '',
  requestType: undefined,
  beusPlanNumber: undefined,
  baPlanNumber: undefined,
  useStartDate: new Date(),
  period: undefined,
  useEndDate: null,
  recurring: false,
  paymentType: 'wire',
  paymentCycle: '0',
  amount: 0,
  paymentDate: new Date(),
  isEndOfMonth: false,
  memo: '',
})

const isSearch =ref<boolean>(false)

const planStore = usePlanStore();
// console.log('Beus', planStore.beusPlanData);
// console.log('Ba', planStore.baPlanData);
const planGroupLabels: Record<string, string> = {
  PAID: '일반',
  ENT: '엔터프라이즈',
  UNUSED: '미사용플랜',
};

const optionsPlan = computed(() => {
  const groupPlans = (planData: any[]) => {
    const grouped: Record<string, typeof planData> = {};
    for (const plan of planData) {
      const group = plan.planGroup || '';
      if (group === 'VOID') continue;
      if (!grouped[group]) grouped[group] = [];
      grouped[group].push(plan);
    }
    return Object.entries(grouped)
      .sort(([a], [b]) => {
        if (a === 'UNUSED') return 1;
        if (b === 'UNUSED') return -1;
        return 0;
      })
      .map(([planGroup, plans]) => ({
        planGroup: planGroupLabels[planGroup] ?? planGroup,
        plans,
      }));
  };

  return {
    beus: groupPlans(planStore.beusPlanData),
    ba: groupPlans(planStore.baPlanData)
  };
});

const defaultEmail = ref('manager')
const disabledEmail = ref('all')

const handleSearchAccount = async () => {

  if (form.userId.length < 1 ) {
    ElMessageBox.alert('검색어를 입력해주세요.', { confirmButtonText: '확인' });
    return
  }

  const params = {
    userId: form.userId
  }

  try {
    // const response = await getUserInfo(params);
    const response = await getCustomerInfo(params);
    // console.log(response);
    if(response.success) {
      if(response.result) {
        const customer = response.result;
        Object.assign(form, {
          baRefer: customer.baRefer,
          beusRefer: customer.beusRefer,
          companyName: customer.companyName,
          customerId: customer.customerId,
          manager: customer.manager,
          taxMail: customer.taxInfo?.taxInfoDetail
        });
        setEmailType(customer.taxInfo)
        isSearch.value = true
      } else {
        Object.assign(form, {
          baRefer: '',
          beusRefer: '',
          companyName: '',
          customerId: '',
          manager: '',
          taxMail: []
        });
        defaultEmail.value = 'manager',
        disabledEmail.value = 'all'
        ElMessageBox.alert('존재하지 않는 계정입니다.', { confirmButtonText: '확인' });
        isSearch.value = false
      }

    }
  } catch (error) {
    isSearch.value = false
    console.error('Error Message:', error);
    ElMessageBox.alert('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.<br/> 문제가 지속되면 관리자에게 문의하세요.', {
      confirmButtonText: '확인',
      dangerouslyUseHTMLString: true
    });
  }
}

const setEmailType = (typeInfo) => {
  if (!typeInfo) {
    documentInputs.value[0].email = 'manager'
    defaultEmail.value = 'manager'
    disabledEmail.value = 'all'
  } else if (typeInfo.taxInfoType === 'SYSTEM') {
    documentInputs.value[0].email = 'system'
    defaultEmail.value = 'system',
    disabledEmail.value = 'tax'
  } else {
    documentInputs.value[0].email = 'tax'
    defaultEmail.value = 'tax',
    disabledEmail.value = 'system'
  }
}

watch(() => form.requestType, (newVal) => {
  if (newVal === null) return;
  const defaultValues = {
    PLAN: { beusPlanNumber: -1, baPlanNumber: -1, useStartDate: new Date(), period: '1', recurring: false },
    PV_CHARGE: { beusPlanNumber: undefined, baPlanNumber: undefined, useStartDate: new Date(), period: '1', recurring: false },
    JAM_CHARGE: { beusPlanNumber: undefined, baPlanNumber: undefined, useStartDate: new Date(), period: '60', recurring: false },
    ADDITIONAL: { beusPlanNumber: undefined, baPlanNumber: undefined, useStartDate: new Date(), period: undefined, recurring: null },
  };

  Object.assign(form, defaultValues[newVal] || {});
});

watch(() => [form.useStartDate, form.period], () => {
  if (form.requestType === 'ADDITIONAL') {
    form.useEndDate = null
  } else {
    const startYear = form.useStartDate.getFullYear();
    const startMonth = form.useStartDate.getMonth();
    const startDate = form.useStartDate.getDate();
    const period = Number(form.period);
    if (startDate >= 29) form.useEndDate = new Date(startYear, startMonth + period + 1, 0);
    else form.useEndDate = new Date(startYear, startMonth + period, startDate - 1);
  }
}, { immediate: true });

const paymentCycleLabels: Record<string, string> = {
  "0": '일시납',
  "1": '월납',
  "2": '격월납',
  "3": '분기납',
  "4": '4개월납',
  "6": '반기납',
};

const optionsPaymentCycle = reactive<string[]>([]);

watch(() => form.period, (newVal) => {
  const period = Number(newVal);
  if (!isNaN(period) && period > 0) {
    optionsPaymentCycle.splice(0, optionsPaymentCycle.length, ...["0", "1", ...Object.keys(paymentCycleLabels)
      .filter(key => Number(key) > 1 && period % Number(key) === 0 && Number(key) !== period)]);

    if (!optionsPaymentCycle.includes(form.paymentCycle)) {
      form.paymentCycle = '0';
    }
  } else {
    optionsPaymentCycle.splice(0, optionsPaymentCycle.length);
    form.paymentCycle = '0';
  }
});

const isEndOfMonthEnabled = (date: Date): boolean => {
  const isLastDayOfMonth = (date: Date): boolean => {
    const nextDay = new Date(date);
    nextDay.setDate(date.getDate() + 1);
    return nextDay.getDate() === 1;
  }

  const month = date.getMonth() + 1;
  const isLastDay = isLastDayOfMonth(date);

  return isLastDay && (month === 2 || [4, 6, 9, 11].includes(month));
}

const documentInputs = ref<Document[]>([{
  docType: 'TAX_INVOICE',
  actionDate: new Date(),
  email: defaultEmail.value,
  periodic: false,
  isEndOfMonth: false
}]);

const chargeType = ref<string>('charged');

const handleChargeType = () => {
  if (chargeType.value === 'charged') {
    form.paymentType = 'wire'
    handleChagePaymentType()
  } else {
    form.paymentType = 'free'
  }
}

const handleChagePaymentType = () => {

  documentInputs.value = documentInputs.value.filter((doc: Document) => doc.docType !== undefined);

  if (form.paymentType === 'wire') {
    const hasTaxInvoice = documentInputs.value.some((doc:Document) => doc.docType === "TAX_INVOICE");

    if (!hasTaxInvoice) {
      documentInputs.value.unshift({
        docType: 'TAX_INVOICE',
        actionDate: new Date(),
        email: 'tax',
        periodic: false,
        isEndOfMonth: false
      })
    }
  } else {
    documentInputs.value = documentInputs.value.filter((doc: Document) => doc.docType !== "TAX_INVOICE");
  }
};

const handleAddDocument = () => {
  documentInputs.value.push({
    docType: undefined,
    actionDate: new Date(),
    email: defaultEmail.value,
    periodic: false,
    isEndOfMonth: false
  });
}

const handleRemoveDocument = (index: number) => documentInputs.value.splice(index, 1);

const handleSubmit = async () => {

  let formData = {
    companyName: form.companyName,
    customerId: form.customerId,
    userId: form.userId,
    baRefer: form.baRefer,
    beusRefer: form.beusRefer,
    manager: form.manager,
    requestType: form.requestType,
    baPlanNumber: form.baPlanNumber === -1 ? null : Number(form.baPlanNumber),
    beusPlanNumber: form.beusPlanNumber === -1 ? null : Number(form.beusPlanNumber),
    useStartDate: moment(form.useStartDate).format('YYYY-MM-DD'),
    useEndDate: form.useEndDate? moment(form.useEndDate).format('YYYY-MM-DD') : null,
    period: Number(form.period),
    recurring: form.recurring,
    paymentType: form.paymentType,
    isEndOfMonth: form.isEndOfMonth,
    memo: form.memo,

  }

  if (chargeType.value === 'charged') {
    const updatedDocumentInput = documentInputs.value
    .filter((doc) => doc.docType !== undefined)
    .map((doc) =>  {
      return {
        ...doc,
        actionDate: moment(doc.actionDate).format('YYYY-MM-DD'),
        email: doc.email === 'tax' ? form.taxMail : doc.email === 'manager' ? form.manager.map(em => em.mail) : 'system',
        periodic: doc.periodic,
        isEndOfMonth: doc.isEndOfMonth
      }
    });

    formData = { ...formData,
      amount: Number(form.amount),
      paymentCycle: Number(form.paymentCycle),
      paymentDate: moment(form.paymentDate).format('YYYY-MM-DD'),
      docs: updatedDocumentInput
    }
  }
  try {
    // console.log(formData)

    if(validateFormData(formData)) {
      const response = await createRequest(formData);
      console.log('리퀘스트 생성 성공:', response);
      ElMessageBox.alert('리퀘스트를 생성했습니다. 보드로 이동합니다.', {
        confirmButtonText: '확인',
        callback: () => {
          router.push({name: 'Board'});
        },
      });
    } else return;
  } catch (error) {
    console.error('Error Message:', error)
    ElMessage.error('리퀘스트 생성에 실패했습니다. 다시 시도해주세요')
  }
};

const userIdInput = ref<InputRef>();
const requestTypeInput = ref<InputRef>();
const beusPlanInput = ref<InputRef>();
const periodInput = ref<InputRef>();
const amountInput = ref<InputRef>();

const validateFormData = (formData: Form) => {
  const showAlertAndFocus = (message: string, inputRef: InputRef | undefined) => {
    ElMessageBox.alert(message, { confirmButtonText: '확인' });
    if (inputRef && inputRef.focus) inputRef.focus();
    return false;
  };

  if (!formData.userId) return showAlertAndFocus('뷰저블 계정을 입력해주세요.', userIdInput.value);
  if (!formData.companyName) return showAlertAndFocus('뷰저블 계정을 정확히 입력해주세요.', userIdInput.value);
  if (!formData.requestType) return showAlertAndFocus('요청 유형을 선택해주세요.', requestTypeInput.value);
  if (formData.requestType === 'PLAN' && formData.beusPlanNumber == null && formData.baPlanNumber == null) return showAlertAndFocus('플랜을 선택해주세요.', beusPlanInput.value);
  if (formData.requestType !== 'ADDITIONAL' && (isNaN(formData.period) || formData.period <= 0)) return showAlertAndFocus('계약 개월 수를 바르게 입력해주세요.', periodInput.value);
  if (chargeType.value === 'charged' && (isNaN(formData.amount) || formData.amount <= 0)) return showAlertAndFocus('금액을 바르게 입력해주세요.', amountInput.value);

  return true;
};
const setPlanDisabledDate = (date: Date) => {
  const start = new Date(form.useStartDate);
  const target = new Date(start.setDate(start.getDate() + 1))
  target.setHours(0, 0, 0, 0);
  return date < target;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "tit-h2" }, " 리퀘스트 추가 ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          "aria-label": "이전으로",
          class: "btn-icon",
          onClick: toBack
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrow-left-long" })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_form, {
      model: form,
      "label-position": "left",
      "label-width": "100px",
      class: "content-box"
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_4, [
          _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "tit-h3" }, " 고객 정보 ", -1)),
          _createVNode(_component_el_form_item, { label: "뷰저블 계정" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElInput), {
                modelValue: form.userId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.userId) = $event)),
                size: "large",
                style: {"width":"300px"},
                ref_key: "userIdInput",
                ref: userIdInput,
                onKeyup: _withKeys(handleSearchAccount, ["enter"])
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    "aria-label": "검색",
                    onClick: handleSearchAccount
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-magnifying-glass" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "회사명" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(form.companyName), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            label: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode(" 히트맵"),
              _createElementVNode("br", null, null, -1),
              _createTextVNode("추천인 코드 ")
            ])),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(form.beusRefer), 1)
              ]),
              (isSearch.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(['input-status', {'active' : form.beusRefer }])
                  }, [
                    _createTextVNode(_toDisplayString(form.beusRefer ? '적용됨' : '미적용') + " ", 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(`icon ${form.beusRefer ? 'icon--checked' : 'icon--info'}`)
                    }, null, 2)
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "저니맵 추천인 코드" }, {
            label: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode(" 저니맵"),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" 추천인 코드 ")
            ])),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(form.baRefer), 1)
              ]),
              (isSearch.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(['input-status', {'active' : form.beusRefer }])
                  }, [
                    _createTextVNode(_toDisplayString(form.baRefer ? '적용됨' : '미적용') + " ", 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(`icon ${form.baRefer ? 'icon--checked' : 'icon--info'}`)
                    }, null, 2)
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "담당자 정보" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.manager, (manager) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "viewer__item",
                      key: manager.name
                    }, _toDisplayString(manager.name) + " / " + _toDisplayString(manager.mail) + _toDisplayString(manager.phone ? ` / ${_unref(formatPhonNumber)(manager.phone)}` : ''), 1))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: `세금계산서\n발행 정보` }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  (form.companyName)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(form.taxMail ? form.taxMail.join(', ') : 'N/A'), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["detail-info-wrapper", {disabled: !form.customerId}])
        }, [
          _createElementVNode("section", _hoisted_15, [
            _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "tit-h3" }, " 요청 상세 정보 ", -1)),
            _createVNode(_component_el_form_item, { label: "요청 유형" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElSelect), {
                  modelValue: form.requestType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.requestType) = $event)),
                  placeholder: "선택하세요.",
                  size: "large",
                  style: {"width":"170px"},
                  ref_key: "requestTypeInput",
                  ref: requestTypeInput
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(optionsReqType), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_component_el_form_item, { label: "히트맵 플랜" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElSelect), {
                  modelValue: form.beusPlanNumber,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.beusPlanNumber) = $event)),
                  placeholder: "선택하세요.",
                  size: "large",
                  style: {"width":"240px"},
                  ref_key: "beusPlanInput",
                  ref: beusPlanInput
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_el_option, {
                      key: -1,
                      label: "Not applicable",
                      value: -1
                    })),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsPlan.value.beus, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option_group, {
                        key: group.planGroup,
                        label: group.planGroup
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.plans, (plan) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: plan._id,
                              label: plan.planName,
                              value: plan.planNumber
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_text, { type: "danger" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-circle-exclamation" }),
                    _cache[19] || (_cache[19] = _createTextVNode(" 변경이 필요한지 확인하세요")),
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "" }, null, -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, form.requestType === 'PLAN']
            ]),
            _withDirectives(_createVNode(_component_el_form_item, { label: "저니맵 플랜" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElSelect), {
                  modelValue: form.baPlanNumber,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.baPlanNumber) = $event)),
                  placeholder: "선택하세요.",
                  size: "large",
                  style: {"width":"240px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_el_option, {
                      key: -1,
                      label: "Not applicable",
                      value: -1
                    })),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsPlan.value.ba, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option_group, {
                        key: group.planGroup,
                        label: group.planGroup
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.plans, (plan) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: plan._id,
                              label: plan.planName,
                              value: plan.planNumber
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_text, { type: "danger" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-circle-exclamation" }),
                    _cache[21] || (_cache[21] = _createTextVNode(" 변경이 필요한지 확인하세요. "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, form.requestType === 'PLAN']
            ]),
            (form.requestType)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "사용 시작일"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: form.useStartDate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.useStartDate) = $event)),
                      type: "date",
                      placeholder: "선택하세요",
                      size: "large",
                      style: {"width":"170px"},
                      clearable: false,
                      "disabled-date": _unref(disablePastDates)
                    }, null, 8, ["modelValue", "disabled-date"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_el_form_item, { label: "계약 개월 수" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  modelValue: form.period,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.period) = $event)),
                  size: "large",
                  style: {"width":"60px"},
                  class: "input-period",
                  ref_key: "periodInput",
                  ref: periodInput
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_text, { type: "danger" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-circle-exclamation" }),
                    _cache[22] || (_cache[22] = _createTextVNode(" 변경이 필요한지 확인하세요. "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, (form.requestType === 'PLAN' || form.requestType === 'PV_CHARGE' || form.requestType === 'JAM_CHARGE') && !(form.requestType === 'PV_CHARGE' || form.requestType === 'JAM_CHARGE')]
            ]),
            _withDirectives(_createVNode(_component_el_form_item, { label: "사용 종료일" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: form.useEndDate,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.useEndDate) = $event)),
                  disabled: form.requestType !== 'PV_CHARGE',
                  type: "date",
                  size: "large",
                  style: {"width":"170px"},
                  "disabled-date": setPlanDisabledDate
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 512), [
              [_vShow, form.period]
            ]),
            _withDirectives(_createVNode(_component_el_form_item, { label: "자동 갱신 여부" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.recurring,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.recurring) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { value: true }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode(" 예 ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { value: false }, {
                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                        _createTextVNode(" 아니오 ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 512), [
              [_vShow, form.requestType === 'PLAN' || form.requestType === 'PV_CHARGE' || form.requestType === 'JAM_CHARGE']
            ])
          ]),
          _createElementVNode("section", _hoisted_16, [
            _cache[34] || (_cache[34] = _createElementVNode("h3", { class: "tit-h3" }, " 결제 정보 ", -1)),
            _createVNode(_component_el_form_item, { label: "제공 방식" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: chargeType.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((chargeType).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      value: "charged",
                      onChange: handleChargeType
                    }, {
                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                        _createTextVNode(" 유상 ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      value: "free",
                      onChange: handleChargeType
                    }, {
                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                        _createTextVNode(" 무상 ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (chargeType.value === 'charged')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_form_item, { label: "결제 방식" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: form.paymentType,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.paymentType) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, {
                            value: "wire",
                            onChange: handleChagePaymentType
                          }, {
                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                              _createTextVNode(" 무통장 ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, {
                            value: "card",
                            onChange: handleChagePaymentType
                          }, {
                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                              _createTextVNode(" 카드 ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_el_form_item, { label: "결제 주기" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElSelect), {
                        modelValue: form.paymentCycle,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.paymentCycle) = $event)),
                        size: "large",
                        style: {"width":"170px"},
                        placeholder: "선택하세요."
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsPaymentCycle, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: paymentCycleLabels[item],
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, form.period && form.requestType === 'PLAN' && Number(form.period) > 1]
                  ]),
                  _createVNode(_component_el_form_item, { label: "결제 금액" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: form.amount,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.amount) = $event)),
                        formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                        parser: (value) => value.replace(/\$\s?|(,*)/g, ''),
                        size: "large",
                        style: {"width":"170px"},
                        class: "input-price",
                        ref_key: "amountInput",
                        ref: amountInput
                      }, {
                        append: _withCtx(() => _cache[30] || (_cache[30] = [
                          _createTextVNode(" 원 ")
                        ])),
                        _: 1
                      }, 8, ["modelValue", "formatter", "parser"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "결제일" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: form.paymentDate,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.paymentDate) = $event)),
                        type: "date",
                        placeholder: "선택하세요",
                        size: "large",
                        style: {"width":"170px"},
                        clearable: false,
                        "disabled-date": _unref(disablePastDates)
                      }, null, 8, ["modelValue", "disabled-date"]),
                      (form.paymentCycle !== '0')
                        ? (_openBlock(), _createBlock(_component_el_checkbox, {
                            key: 0,
                            disabled: !isEndOfMonthEnabled(form.paymentDate),
                            modelValue: form.isEndOfMonth,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.isEndOfMonth) = $event))
                          }, {
                            default: _withCtx(() => _cache[31] || (_cache[31] = [
                              _createTextVNode(" 해당 월 마지막 날짜에 결제 ")
                            ])),
                            _: 1
                          }, 8, ["disabled", "modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "서류 발행" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentInputs.value, (documentInput, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "document-row",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_unref(ElSelect), {
                              modelValue: documentInput.docType,
                              "onUpdate:modelValue": ($event: any) => ((documentInput.docType) = $event),
                              placeholder: "서류 유형",
                              size: "large",
                              style: {"width":"120px"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(optionsDocumentType), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_el_date_picker, {
                              modelValue: documentInput.actionDate,
                              "onUpdate:modelValue": ($event: any) => ((documentInput.actionDate) = $event),
                              type: "date",
                              placeholder: "발행일 선택",
                              size: "large",
                              style: {"width":"130px"},
                              clearable: false,
                              "disabled-date": _unref(disablePastDates)
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled-date"])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_unref(ElSelect), {
                              modelValue: documentInput.email,
                              "onUpdate:modelValue": ($event: any) => ((documentInput.email) = $event),
                              placeholder: "발행 이메일",
                              size: "large",
                              style: {"width":"200px"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.optionsIssueEmail, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value,
                                    class: _normalizeClass({disabled: (disabledEmail.value === 'all' && item.value !== 'manager') || disabledEmail.value === item.value})
                                  }, null, 8, ["label", "value", "class"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            (form.period && form.requestType === 'PLAN' && form.paymentCycle !== '0')
                              ? (_openBlock(), _createBlock(_component_el_checkbox, {
                                  key: 0,
                                  modelValue: documentInput.periodic,
                                  "onUpdate:modelValue": ($event: any) => ((documentInput.periodic) = $event),
                                  label: "주기별 발행"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (form.period && form.requestType === 'PLAN' && form.paymentCycle !== '0' && documentInput.periodic)
                              ? (_openBlock(), _createBlock(_component_el_checkbox, {
                                  key: 1,
                                  disabled: !isEndOfMonthEnabled(documentInput.actionDate),
                                  modelValue: documentInput.isEndOfMonth,
                                  "onUpdate:modelValue": ($event: any) => ((documentInput.isEndOfMonth) = $event)
                                }, {
                                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                                    _createTextVNode(" 해당 월 마지막 날짜에 결제 ")
                                  ])),
                                  _: 2
                                }, 1032, ["disabled", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          (!(form.paymentType === 'wire' && documentInput.docType === 'TAX_INVOICE'))
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                text: "",
                                round: "",
                                "aria-label": "삭제",
                                onClick: ($event: any) => (handleRemoveDocument(index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-trash-can" })
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        plain: "",
                        onClick: handleAddDocument
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-plus" }),
                          _cache[33] || (_cache[33] = _createTextVNode(" 추가 "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("section", _hoisted_21, [
            _cache[35] || (_cache[35] = _createElementVNode("h3", { class: "tit-h3" }, " 메모 ", -1)),
            _createVNode(_unref(ElInput), {
              modelValue: form.memo,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.memo) = $event)),
              rows: 5,
              type: "textarea",
              placeholder: "입력하세요"
            }, null, 8, ["modelValue"])
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => _cache[36] || (_cache[36] = [
          _createTextVNode(" 저장 ")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "default",
        size: "large",
        onClick: toBoard
      }, {
        default: _withCtx(() => _cache[37] || (_cache[37] = [
          _createTextVNode(" 취소 ")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})